export default function ContractCPA({
  isChecked,
  handleCheckboxChange,
  handleNextButtonClick,
}) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker CPA方案</div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          Becker 方案購買須知與同意事項  (請務必詳閱)
        </h5>
        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            <ol>
              <li>
                <div className="font-weight-bold">購買方案者，須填妥本訂購單資料表，完整審閱同意事項後，完成付費，方符合訂購程序。繳費前，請先確認購買產品內容與費用。</div>
                <ul>
                  <li>購買前請確認完整審閱此份購買須知與相關規定，審閱期已達五日。</li>
                  <li>本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第2條可排除消費者保護法第19條七日解除權之合理例外情事者，惟若商品未經領取、未開始參加課程、且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費（若已取得諮詢者，退費時需扣除每階段 1,000元諮詢費）。</li>
                  <li>教材一經領取或帳號登入後，恕不退費亦不得要求暫停效期。</li>
                  <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知，利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。因非可歸責於 Becker Taiwan (捷進)之事由導致登入密碼外洩時， 學員應儘速通知，Becker Taiwan (捷進)除提供必要協助外，不負任何法律上責任。</li>
                  <li>購買方案者保證為完全行為能力人或已得法定代理人同意之限制行為能力人。</li>
                  <li>使用本服務應具備下列之軟硬體設備基本規格及要求：
                    <ul>
                      <li>Windows PC/NB：Windows 7 以上</li>
                      <li>Apple PC/NB：macOS 10 以上</li>
                      <li>Apple 行動裝置：iOS 13.0 以上</li>
                      <li>Android 行動裝置：Android 8.0 以上</li>
                      <li>※注意事項：行動裝置限定使用APP版觀看課程<br/>
                          連線需求：寬頻網路下載速度20Mbps以上</li>
                      <li>不建議無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
                    </ul>
                  </li>
                  <li>※注意事項：行動裝置限定使用APP版觀看課程。<br/>
                      ※其餘未列示之軟硬體或系統，恕不保證其觀看學習品質</li>
                </ul>
              </li>
              <li>學員資料表 E-mail 信箱資訊，有效期限必須達二十四個月以上，購買後請自行定期收信，本軟體服務及一切相關資訊將以該 E-mail 信箱為聯繫方式，若因學員未定期收信導致權益受影響，學員應自負其責。</li>
              <li>
                Becker CPA Exam Review 系列為美國進口原版教材與軟體，方案內含之教材、課程、諮詢服務皆限購買者個人使用，學員應遵循 Becker 服務政策，且嚴禁任何形式之轉售、轉贈、轉讓及分享，若經發現，學員應賠償購買總價10倍之懲罰性違約金及損害賠償。
                <ul>
                  <li>使用權限效期：
                    <ul>
                      <li>美國註冊會計師系列 Becker CPA Exam Review 與 Becker CPA Exam Final Review 使用權限效期於軟體購買當日起算後之二十四個月後終止。(Your Becker CPA Exam Review license will expire 24 months from the date of purchase.)</li>
                    </ul>
                  </li>
                  <li>2025年1月1日起，CPA 所有方案提供電子教科書，不包含紙本教科書。因個人筆記習慣須加購教科書者，每本需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費。</li>
                  <li>所有方案內含之服務、課程、課本，需於效期內領取與使用。</li>
                  <li>購買 CPA 專業方案、全修方案者，符合持續展延 (Unlimited Access) 使用條款(見第4項)。</li>
                  <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education與 Becker Taiwan (捷進) 將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址 (IP address) 等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況， Becker Taiwan (捷進) 有權中止該帳號之軟體權限。</li>
                  <li>遇 Becker 系列教科書版本更新、而須加購新版書本者，需於使用效期內，檢附「過去三個月內應考而成績未及格證明」或「即將赴考之考場預約 (exam appointment confirmation) 證明」做為購買憑證，每本書需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費。</li>
                  <li>若遇書籍取用完畢，需等待國際郵務寄達台灣，無法指定取書時間。</li>
                </ul>
              </li>
              <li>終止契約 學員如有違反強制禁止規定或公序良俗之行為、或違反本契約經限期改正仍未改正者， Becker Taiwan (捷進) 得終止本契約，不得異議。如學員自行或因可歸責於己之事由終止契約者，教材一經領取或帳號登入後，恕不退費。</li>
              <li>持續展延 (Unlimited Access) 條款
                <ul>
                  <li>購買 Becker CPA「含」持續展延資格產品之學員，於使用效期內，可立即適用持續展延條款；未符合以上資格而僅購買 Becker CPA「無」持續展延資格產品之學員，於使用效期內得以價差加購持續展延資格。</li>
                  <li>展延申請方式：
                    <ul>
                      <li>CPA （美國註冊會計師）：
                        <ul>
                          <li>持有持續展延資格之 CPA 學員，每一次使用權限到期日前30日內，需提出學員本人「即將赴考某科目之考場預約 (Prometric appointment confirmation) 證明」，即得展延該科軟體效期六個月，無須額外付費。未能於到期日前提出申請並通過審核者，即喪失效期和持續展延申請資格。</li>
                          <li>軟體效期若獲免費展延，延長之效期起算日為原有到期日之隔天，不得提早或延後起算。</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>Becker Taiwan (捷進) 中文課程產品內容說明與限制：
                <ul>
                  <li>中文課程使用原則
                    <ul>
                      <li>CPA（美國註冊會計師）：
                        <ul>
                          <li>學員購買套組含加值服務之各類型中文課程者，全科學員得免費使用之總時數額度為購買當年一期四科面授時數加上四十小時，非全科學員使用之總時數額度為單科面授時數加上十小時。</li>
                          <li>專業、全修、選修方案內含之面授、或雲端中文課程，學員可以依所持時數額度，選擇以面授、或雲端型式使用，依逐次使用時數扣除額度，使用後不得要求變更、轉讓以及重複行使權益，首次登入軟體當日視為實際開課日。</li>
                          <li>學員單科選擇面授型式，需於於軟體效期內選擇一期之該科面授課程預定教室座位名額，完整參加，單科不得要求分期上課；面授一堂為三小時，乘上該科堂數由學員使用時數額度中扣除。</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>全系列產品各方案可能包含之面授、或雲端課程、線上發問系統、顧問諮詢等在地中文加值服務之使用有效期限與軟體效期一致。
                    <ul>
                      <li>學員軟體使用效期結束時，若未使用完畢加值服務之各類型課程時數，剩餘時數等同失效，不得異議。</li>
                      <li>中文課程研發目的在幫助考生加速通過考試，故學員使用或參加中文課程時間點為通過考試之前。</li>
                      <li>面授、或雲端課程中不得針對內容進行任何錄音、錄影等側錄行為。</li>
                      <li>購買「無」中文課程產品者，不得要求索取中文加值服務之各項研習講義、文件資料。</li>
                      <li>全系列各方案可能內含之中文課程，提供有面授、或雲端上課型式，Becker Taiwan (捷進) 保有各上課形式之開課時間、現場空間開放時間、雲端影片開放時間之決定權，學員不得異議。</li>
                      <li>使用面授課程者若有缺課情況，缺席課程以雲端內容進行補課，補課時數與面授缺席時數相同，不得要求增加時數。</li>
                      <li>Becker Taiwan (捷進) 保有中文課程開課日期之決定權，依各期實際開課公告認定，學員不得異議。</li>
                      <li>學員單科選擇雲端型式，可於軟體效期內隨時使用，每次申請並使用觀看點數為計算憑證，由學員使用時數額度中扣除。每一點數代表三小時上課時數。</li>
                      <li>Becker Taiwan (捷進) 保有中文雲端課程於雲端提供時間點、提供內容範圍之決定權，依各期課程影片上架公告認定，學員不得異議。</li>
                    </ul>
                  </li>
                  <li>學員購買方案含加值服務之各類型課程者，免費時數額度用罄情況，於軟體有效效期內，得以單堂三小時為單位加購使用額度
                    <ul>
                      <li>曾購買全科方案者，單堂加購金額為台幣一千五百元整。</li>
                      <li>曾購買非全科方案者，單堂加購金額為台幣兩千五百元整。</li>
                    </ul>
                  </li>
                  <li>Becker Taiwan (捷進) 保有各項諮詢服務、教室座位、雲端流量分配之決定權，學員欲使用上開服務均須提前來電或來信預約，以確認實體辦公室與面授教室服務狀態與起迄時間。</li>
                  <li>配合中華民國各級政府單位規定，遇天災、疫情、緊急事件時獲所屬區域政府單位指示，Becker Taiwan (捷進) 將依指示暫時關閉實體教室場域，學員需待解除關閉後，參加面授課程，不得異議。</li>
                  <li>以上中文課程項目與內容，Becker Taiwan (捷進) 保留變更、終止、修改及解釋之權利。</li>
                </ul>
              </li>
              <li>Becker Taiwan (捷進) 提供之考程顧問諮詢服務，係指由開始準備至通過全科考試為止之報考流程顧問諮詢說明與文件總檢服務。
                <ul>
                  <li>CPA（美國註冊會計師）：
                    <ul>
                      <li>針對購買專業與全科方案者，提供即時透過網路或電話進行之諮詢，另提供選擇性現場諮詢、每次至多30分鐘；為保障雙方權益，現場諮詢過程可能將全程錄音。</li>
                      <li>針對購買選修方案者，提供三次諮詢，單次為20分鐘，各次諮詢範圍明確定義如下，學員不得要求超出此限外之諮詢時間與內容：
                        <ul>
                          <li>第一次諮詢內容：選州流程說明</li>
                          <li>第二次諮詢內容：學歷認證流程說明</li>
                          <li>第三次諮詢內容：報名考試與預約考場流程說明</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>報考流程顧問諮詢說明與文件總檢服務為購買者(學員)本人之權益，為避免溝通有誤或疏漏，流程說明與對話皆僅提供予購買者本人。</li>
                </ul>
              </li>
              <li>捷進顧問有限公司 (Becker Taiwan) 學分評估僅供參考不得視為保證，購買者之報考資格應以考試指定之認證機構以及報名審查官方機構出具之審查結果為準。</li>
              <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，賣方亦保留任何因賣方代理原廠更改貨品規格而更改之權利並對此不負擔責任。</li>
              <li>捷進顧問有限公司 (Becker Taiwan) 已依照台北市短期補習班管理規則之規定立案登記，並已加入中華民國補教業品保協會辦理之補習服務聯合連帶保證協定 (品保協會會員編號：020267)。
                <ul>
                  <li>購買捷進顧問有限公司 (Becker Taiwan) 任一方案者，享有聯合服務連帶保證協定，如 Becker Taiwan (捷進) 因財務或其他原因等問題致其補習服務無法提供，學生得於地方主管機關認定其無法提供補習服務時起六個月內向加入本協定之性質相近之補習班 (以同一直轄市或縣市為原則) 換取等值之服務（但不包括原補習服務之贈品或贈送課程）；等值之服務除依一般方式授課外，得以多元之教學方式辦理。</li>
                  <li>隱私權聲明<br/>
                      捷進顧問有限公司感謝您訂購 Becker 教材方案。本公司將依個人資料保護法第8條第1項之要求，向您告知以下事項：<br/>
                      (1) 蒐集目的：依照101年10月1日修正之個人資料保護法之特定目的及個人資料之類別，040行銷、069契約、類似契約或其他法律關係事務、090消費者客戶管理與服務、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務182其他諮詢與顧問服務。<br/>
                      (2) 個人資料類別： C001電子郵件、中文姓名、英文拼音全名、電話號碼。C002金融機構帳戶號碼與姓名。C003身分證字號。C036是否曾訂購本公司產品、得知本公司之管道。C038在職身分C051所屬或畢業學校與科系。<br/>
                      (3) 個人資料利用之期間、地區：我們會在您使用本公司提供服務之期間與地區利用您的個人資料。<br/>
                      (4) 個人資料利用對象及方法：本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。並將分析您提供之類別C036、C038、C051等資訊，以增進本公司之服務。在未經您的同意下，我們不會將您的個人資料提供給第三人或做不當利用。<br/>
                      (5)如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。<br/>
                      (6) 您得行使個資法第3條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。<br/>
                      捷進顧問有限公司 (Becker Taiwan) 附設短期補習班立案資訊<br/>
                      核准立案名稱全名：捷進顧問有限公司附設臺北市私立貝克商業文理短期補習班<br/>
                      核准字號：北市補習班證第7620號<br/>
                      負責人：陸秀麗<br/>
                      <ul>
                        <li>聯絡電話：02-2700-0053</li>
                        <li>地址：臺北市大安區住安里信義路四段6號16樓之12</li>
                        <li>傳真：02-2700-0616</li>
                        <li>電子郵件：service@beckertw.com</li>
                      </ul>
                      付費購買匯款資訊<br/>
                      【在台購買】<br/>
                      收款人戶名：捷進顧問有限公司<br/>
                      受款銀行：華南商業銀行信維分行 (代碼：008 )<br/>
                      收款人帳號：149-10-010062-0<br/>
                      匯款金額：以新台幣付費，依各方案價格 (若需快遞書籍，請加上運費)<br/>
                      台灣境內快遞計費方式：便利袋快遞費每箱新台幣 100 元。因快遞公司重量限制，寄送 1-2 本為一箱，寄送 3-4 本須為兩箱。<br/><br/><br/>


                      __________________<br/>


                      【海外購買】<br/>
                      Recipient Name: Direct Line Consulting Co.<br/>
                      Account Number: 149-10-010062-0<br/>
                      Bank: Hua Nan Commercial Bank Ltd.<br/>
                      Branch: Hsin-Wei Branch<br/>
                      SWIFT Code (Bank ID): HNBKTWTP149<br/>
                      Bank Address: 2F, No.6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan<br/>
                      匯款金額：以新台幣付費，依各方案價格 (若需快遞書籍，請加上運費，全額到匯，計算方式請向您的支付銀行確認，若無法估算，請直接另附新台幣200元之中轉行手續費)<br/>
                      快遞計費方式： 由美國 Becker 直接發貨， 單次寄送郵資為新台幣 1,200 元 。<br/>

                    </li>
                </ul>
              </li>
            </ol>
          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div
              className="btn btn-primary m-3"
              onClick={handleNextButtonClick}
            >
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
